import React from 'react';

/**
 * AccordionContext
 * {
 *  toggle: PropTypes.func.isRequired,
 *  openId: PropTypes.string,
 * }
 */
export const AccordionContext = React.createContext({});
